module.exports = __webpack_public_path__ + "img/reference42.15bed42e.jpg";